import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import Store from '@app/store';
import RouterFunctions from '@app/router/functions';
var prefetchOffset = 500;
var options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5
};
/**
 * Preload page data for a given URL
 *
 * @param url Url to prefetch
 * @param delay Timeout before prefetch starts
 */
var prefetch = function (url, delay) {
    setTimeout(function () {
        if (window.laravelDebug) {
            console.log('🚀 Prefetching ' + url);
        }
        Store.ACTIONS.loadPageData(url).then(function () {
            Vue.set(Store.STATE.pageData[url], '__prefetched__', true);
        });
    }, delay);
};
var intersectionHandler = function (entries, observer) { return __awaiter(void 0, void 0, void 0, function () {
    var intersectingEntries, linksToPrefetch, urls;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Wait for all routes to be loaded before starting to handle intersects
            return [4 /*yield*/, Store.STATE.routesLoaded
                // Only handle entries which are intersecting, immediately unobserve handled elements
            ];
            case 1:
                // Wait for all routes to be loaded before starting to handle intersects
                _a.sent();
                intersectingEntries = entries.filter(function (entry) { return entry.isIntersecting; });
                intersectingEntries.forEach(function (entry) { return observer.unobserve(entry.target); });
                linksToPrefetch = intersectingEntries
                    .map(function (el) { return new URL(el.target.href).pathname; })
                    .filter(function (url) { return !Store.STATE.pageData[url] && RouterFunctions.routeExists(url); });
                urls = Array.from(new Set(linksToPrefetch));
                urls.forEach(function (url, index) {
                    if ('requestIdleCallback' in window) {
                        // @ts-ignore
                        requestIdleCallback(function () { return prefetch(url, 0); }, {
                            timeout: 5000
                        });
                    }
                    else {
                        prefetch(url, index * prefetchOffset);
                    }
                });
                return [2 /*return*/];
        }
    });
}); };
var observer;
if (!('IntersectionObserver' in window) ||
    !('IntersectionObserverEntry' in window) ||
    !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    observer = {
        observe: function (el) {
            // do nothing if IntersectionObserver is not supported
        }
    };
}
else {
    observer = new IntersectionObserver(intersectionHandler, options);
}
export default observer;
